import { cn } from "@/libs/cn";

interface SpinnerProps {
  className?: string;
  message?: string;
  overlay?: boolean;
}

const Spinner = ({ className, message = "Carregando...", overlay = false }: SpinnerProps) => {
  const containerClasses = overlay
    ? "fixed inset-0 flex flex-col items-center justify-center bg-black/20 backdrop-blur-xs z-5"
    : "flex flex-col items-center justify-center w-full h-full";

  return (
    <div className={cn(containerClasses, className)}>
      <div className="relative justify-center w-12 h-12">
        {[...Array(12)].map((_, i) => (
          <div
            key={i}
            className="absolute top-0 left-0 w-full h-full"
            style={{
              transform: `rotate(${i * 30}deg)`,
            }}
          >
            <div
              className={cn("w-2 h-2 rounded-full mx-auto animate-spinner-dot", overlay ? "bg-white" : "bg-[#BDC9EA]")}
              style={{
                animationDelay: `${i * 0.1}s`,
              }}
            />
          </div>
        ))}
      </div>

      {message && <p className={cn("mt-4", overlay ? "text-white text-lg" : "text-[#BDC9EA] text-sm")}>{message}</p>}
    </div>
  );
};

export default Spinner;
